import { ThemeColors } from '../../../'

interface ColorBlock {
  Background: ThemeColors
  FontColor: ThemeColors
  Border: ThemeColors
}

export interface BadgeColors {
  Blue: ColorBlock
  LightGray: ColorBlock
  Gray: ColorBlock
}

export const badgeColors: BadgeColors = {
  Blue: {
    Background: {
      default: 'transparent',
    },
    FontColor: {
      default: 'brand.fg',
    },
    Border: {
      default: 'brand.solid',
    },
  },
  LightGray: {
    Background: {
      default: 'transparent',
    },
    FontColor: {
      default: 'fg.muted',
    },
    Border: {
      default: 'border.default',
    },
  },
  Gray: {
    Background: {
      default: 'transparent',
    },
    FontColor: {
      default: 'fg.default',
    },
    Border: {
      default: 'border.default',
    },
  },
}
